import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { AdminApp } from './admin/AdminApp.tsx';

const root = document.getElementById('root');
if (!root) throw new Error('화면을 담을 자리를 찾지 못했습니다.');

// /admin 은 일손이 관리자 화면(6단계). 소장님 화면과 섞이지 않고 사용 기록도 남기지 않는다.
const admin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');

createRoot(root).render(
  <StrictMode>
    {admin ? <AdminApp /> : <App />}
  </StrictMode>
);
